import React, { type ReactElement, useCallback, useEffect, useState } from 'react'
import { Typography } from '@mui/material'
import theme from 'common/utils/theme'
import { StoreStatus } from 'common/utils/types'
import ThemeSnackbar, { SNACKBAR_VARIANTS } from 'common/ui/theme-snackbar/ThemeSnackbar'
import ThemeButton, { BUTTON_VARIANTS } from 'common/ui/theme-button/ThemeButton'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { format } from 'date-fns'
import { sendVerificationRequest } from 'features/authentication/auth.service'

import { VendorStatus } from '../vendor.types'
import { changeVendorStatus } from '../vendor.slice'

import styles from './RequestVerfication.module.scss'

const RequestVerification: React.FC = (): ReactElement => {
  const dispatch = useAppDispatch()

  const { vendor } = useAppSelector((state) => state.vendor)
  const { sendVerificationRequestStatus } = useAppSelector((state) => state.auth)
  const [formattedDate, setFormattedDate] = useState<string>('')
  const [disableRequestVerification, setDisableRequestVerification] = useState<boolean>(true)
  const [openSnackbar, setOpenSnackbar] = useState<boolean>(false)
  const [snackbarMessage, setSnackbarMessage] = useState<string>('')
  const [snackbarVariant, setSnackbarVariant] = useState<SNACKBAR_VARIANTS | undefined>(undefined)

  useEffect(() => {
    if (vendor?.verificationRetryDate) {
      const date = new Date(vendor.verificationRetryDate)
      const currentDate = new Date()
      if (date.getTime() < currentDate.getTime()) {
        setDisableRequestVerification(false)
      }
      setFormattedDate(format(date, 'dd.MM.yyyy'))
    }
  }, [vendor])

  const onSendRequestClick = useCallback(() => {
    void dispatch(sendVerificationRequest()).then(
      (res) => {
        if (res.meta.requestStatus === 'rejected') {
          setSnackbarVariant(SNACKBAR_VARIANTS.error)
          setSnackbarMessage('Greška prilikom slanja zahteva')
          setOpenSnackbar(true)
        }
        dispatch(changeVendorStatus(VendorStatus.pendingVerification))
      },
      () => {
        setSnackbarVariant(SNACKBAR_VARIANTS.error)
        setSnackbarMessage('Greška prilikom slanja zahteva')
        setOpenSnackbar(true)
      },
    )
  }, [dispatch])

  return (
    <div className={styles.wrapper}>
      <Typography variant="title3">Datum kada možete ponovo da zatražite verifikaciju</Typography>
      <div className={styles.content}>
        <div className={styles.dateContent}>
          <Typography variant="title3">{formattedDate || ''}</Typography>
        </div>
        <div className={styles.buttonContent}>
          <ThemeButton
            variant={BUTTON_VARIANTS.contained}
            style={
              disableRequestVerification || sendVerificationRequestStatus === StoreStatus.Loading
                ? {}
                : { backgroundColor: theme.palette.blue.main }
            }
            onClick={onSendRequestClick}
            disabled={disableRequestVerification || sendVerificationRequestStatus === StoreStatus.Loading}
          >
            <Typography variant="title3" className={styles.buttonText}>
              POŠALJI ZAHTEV
            </Typography>
          </ThemeButton>
        </div>
      </div>
      <ThemeSnackbar
        snackbarOpen={openSnackbar}
        variant={snackbarVariant}
        message={snackbarMessage}
        onClose={() => {
          setOpenSnackbar(false)
          setSnackbarMessage('')
        }}
      />
    </div>
  )
}

export default RequestVerification
